export const ALPHA = 'alpha'
export const PRIVATE = 'private'
export const BETA = 'beta'
export const GAMMA = 'gamma'
export const EVIDENCE_BETA1 = 'evidence_beta1'
export const EVIDENCE_BETA2 = 'evidence_beta2'
export const EVIDENCE_PRE_BETA = 'evidence_pre-beta'
export const COLLEGE_BOARD = 'college_board'
export const PRODUCTION = 'production'
export const ARCHIVED = 'archived'

export const EVIDENCE_BETA_FLAGS = [EVIDENCE_BETA1, EVIDENCE_BETA2]

export const flagOptions = [
  {
    label: ALPHA,
    value: ALPHA
  },
  {
    label: PRIVATE,
    value: PRIVATE
  },
  {
    label: BETA,
    value: BETA
  },
  {
    label: GAMMA,
    value: GAMMA
  },
  {
    label: 'Evidence Beta 1',
    value: EVIDENCE_BETA1
  },
  {
    label: 'Evidence Beta 2',
    value: EVIDENCE_BETA2
  },
  {
    label: 'Evidence Pre-Beta',
    value: EVIDENCE_PRE_BETA
  },
  {
    label: 'College Board',
    value: COLLEGE_BOARD
  },
  {
    label: 'production',
    value: PRODUCTION
  },
  {
    label: 'archived',
    value: ARCHIVED
  },
];

export const lessonFlagOptions = flagOptions.filter(option => [
  ALPHA,
  PRIVATE,
  BETA,
  GAMMA,
  PRODUCTION,
  ARCHIVED
].includes(option.value));
